<template>
    <div>
        <trip-table></trip-table>
    </div>
</template>

<script>
    import TripTable from '../custom-components/TripTable.vue';

    export default {
        components: {
            'trip-table': TripTable
        }
    }
</script>

<style scoped lang="less">
    main {
        display: block;
        overflow: hidden;
    }

    .header-widgets {
        display: flex;
        justify-content: flex-end;
        @media (max-width: 1270px) {
            justify-content: space-around;
        }
        align-self: stretch;
        align-items: center;
        height: 100%;
        padding: 1em;
        button {
            @media (max-width: 1270px) {
                align-self: stretch;
                flex-grow: 1;
            }
        }
    }
</style>